/**
 * Currency Context
 * Global currency state management using React Context
 * Similar to FreshaApp implementation
 */

import React, { createContext, useContext, useState, useEffect } from 'react'
import { useSalon } from './SalonContext'

const CurrencyContext = createContext()

export const CurrencyProvider = ({ children }) => {
  const [currency, setCurrencyState] = useState('USD') // Default currency
  const [loading, setLoading] = useState(true)
  const { selectedSalon, salonReady } = useSalon()

  useEffect(() => {
    const loadCurrency = async () => {
      try {
        setLoading(true)
        if (selectedSalon?.currency) {
          setCurrencyState(selectedSalon.currency)
        }
      } catch (error) {
        console.error('Error loading currency:', error)
      } finally {
        setLoading(false)
      }
    }

    if (salonReady) loadCurrency()
  }, [salonReady, selectedSalon?.currency])

  return (
    <CurrencyContext.Provider value={{ currency, loading }}>
      {children}
    </CurrencyContext.Provider>
  )
}

export const useCurrency = () => {
  const context = useContext(CurrencyContext)
  if (!context) {
    throw new Error('useCurrency must be used within a CurrencyProvider')
  }
  return context
}

export default CurrencyContext

